// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const DemandOut = zod.object({
  "archive_reason": zod.union([zod.enum(['opportunity', 'covered', 'not_relevant']),zod.null()]),
  "archived_at": zod.union([zod.iso.datetime({"offset":true}),zod.null()]),
  "archived_by": zod.union([zod.string(),zod.null()]),
  "constraints": zod.array(zod.string()),
  "country": zod.union([zod.string(),zod.null()]),
  "created_at": zod.iso.datetime({"offset":true}),
  "id": zod.uuid(),
  "industry": zod.union([zod.string(),zod.null()]),
  "needs": zod.array(zod.string()),
  "source": zod.string(),
  "summary": zod.string()
});

export type DemandOut = zod.input<typeof DemandOut>;
export type DemandOutOutput = zod.output<typeof DemandOut>;
